import { IVillageCounterSetSchema } from '../../../node/repositories/countryside-search/entities/counter/VillageCounterSetSchema';
import { ISeoDataSchema } from '../../../node/repositories/countryside-search/entities/seo/SeoDataSchema';
import { getCounterSetOnSale } from './helpers';

export function showSerpLink(
  offersSeo: ISeoDataSchema | null | undefined,
  counterSet: IVillageCounterSetSchema | null | undefined,
) {
  const villageSerpLink = offersSeo && offersSeo.url;
  const canSowLink = !!villageSerpLink && !!getCounterSetOnSale(counterSet);

  return canSowLink;
}
